import React from "react";
import { Tabs } from "antd";
import KeywordResearchTableContainer from "../../containers/KeywordResearch/KeywordResearchTableContainer";

const { TabPane } = Tabs;

function KeywordResearchTabs({ researchTypes, selectedResearchType, onTabChange, keyword, seoDb }) {
  return (
    <Tabs
      defaultActiveKey={selectedResearchType}
      onChange={onTabChange}
      type="card"
      tabBarGutter={10}
      data-cy="keyword-research-tabs">
      {researchTypes.map(type => (
        <TabPane tab={type.title} key={type.key}>
          <KeywordResearchTableContainer keyword={keyword} seoDb={seoDb} />
        </TabPane>
      ))}
    </Tabs>
  );
}

export default KeywordResearchTabs;
